'use client'

import Icon from '@mui/material/Icon'
import Tooltip from '@mui/material/Tooltip'
import { SxProps } from '@mui/system'

import { Cats, allCats } from '../../constants/config/categories'
import { iconFontSize } from '../../styles/globalStyles'
import { capitalizeFirstLetter } from '../../utils/textFunc'

export interface CatIconProps {
  cat: Cats | ''
  color?:
  | 'inherit'
  | 'action'
  | 'disabled'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'
  disabled?: boolean
  mini?: boolean
  tiny?: boolean
  extraLarge?: boolean
  edit?: boolean
  showTooltip?: boolean
  toolTipText?: string
  blankIcon?: string
  size?: number | string
  sx?: SxProps
}

export default function CatIcon({
  cat,
  mini,
  tiny,
  extraLarge,
  edit,
  color = 'inherit',
  disabled,
  showTooltip = true,
  toolTipText,
  blankIcon,
  size,
  sx,
}: CatIconProps) {
  const getCatName = () =>
  (
    cat &&
    allCats.find((cate) => {
      const catVal = cat
      const resultFound = cate.val === catVal
      if (resultFound) {
        return resultFound
      } else {
        return false
      }
    })
  )
  const catName = getCatName()

  const catIcon = catName && catName.icon ? catName.icon : blankIcon ? blankIcon : 'view_comfy'

  const defaultToolTipTxt = showTooltip
    ? edit && catName
      ? `Change category${catName.val ? `: ${catName.val}` : ''}`
      : `${capitalizeFirstLetter(cat)}`
    : `${capitalizeFirstLetter(cat)}`

  const toolTipTxt = toolTipText ? toolTipText : defaultToolTipTxt

  const fontSize = tiny
    ? 'tiny'
    : mini
      ? 'mini'
      : extraLarge
        ? 'extra-large'
        : 'large'

  const icon = (
    <Icon
      color={disabled ? 'disabled' : color ? color : 'action'}
      style={{
        fontSize: size || iconFontSize(fontSize),
      }}
      sx={sx}
    >
      {catIcon}
    </Icon>
  )

  if (showTooltip || toolTipTxt) {
    return <Tooltip title={toolTipTxt} placement="left">{icon}</Tooltip>
  } else {
    return icon
  }
}
